<script>
  import { createEventDispatcher, onMount } from "svelte";
  import ResultChartRadar from "./ResultChartRadar.svelte";
  import TextToSpeech2 from "./TextToSpeech2.svelte";
  import { getDataOutside } from "../Utils.svelte";
  import {
    convertSecToMin,
    mapPronToIpa,
  } from "../../../utils/FormatUtils.svelte";
  import { BASE_URL } from "../../../components/DataStore";
  import { _ } from "svelte-i18n";
  import { processBlobToWav } from "../../../utils/CodecUtils.svelte";

  import * as animateScroll from "svelte-scrollto";

  export let resultData; // = JSON.parse('{"exerciseKey":"cyWnql","studentName":"abc","fileName":"R_cyWnql_READ_abc_2020-12-22T21:35:49.882Z","data":{"RecognitionStatus":"Success","Offset":9300000,"Duration":11200000,"NBest":[{"Lexical":"Please read this text for me","ITN":"Please read this text for me","MaskedITN":"please read this text for me","Display":"Please read this text for me.","AccuracyScore":26,"FluencyScore":42,"CompletenessScore":33,"PronScore":30.6,"Words":[{"Word":"Please","AccuracyScore":0,"ErrorType":"Mispronunciation","Offset":9800000,"Duration":1100000,"Phonemes":[{"Phoneme":"p","AccuracyScore":0,"Offset":9800000,"Duration":200000},{"Phoneme":"l","AccuracyScore":0,"Offset":10100000,"Duration":200000},{"Phoneme":"iy","AccuracyScore":0,"Offset":10400000,"Duration":200000},{"Phoneme":"z","AccuracyScore":0,"Offset":10700000,"Duration":200000}]},{"Word":"read","AccuracyScore":15,"ErrorType":"Mispronunciation","Offset":11000000,"Duration":800000,"Phonemes":[{"Phoneme":"r","AccuracyScore":0,"Offset":11000000,"Duration":200000},{"Phoneme":"eh","AccuracyScore":0,"Offset":11300000,"Duration":200000},{"Phoneme":"d","AccuracyScore":46,"Offset":11600000,"Duration":200000}]},{"Word":"this","AccuracyScore":0,"ErrorType":"Mispronunciation","Offset":11900000,"Duration":800000,"Phonemes":[{"Phoneme":"dh","AccuracyScore":0,"Offset":11900000,"Duration":200000},{"Phoneme":"ih","AccuracyScore":0,"Offset":12200000,"Duration":200000},{"Phoneme":"s","AccuracyScore":0,"Offset":12500000,"Duration":200000}]},{"Word":"text","AccuracyScore":4,"ErrorType":"Mispronunciation","Offset":12800000,"Duration":1400000,"Phonemes":[{"Phoneme":"t","AccuracyScore":0,"Offset":12800000,"Duration":200000},{"Phoneme":"eh","AccuracyScore":0,"Offset":13100000,"Duration":200000},{"Phoneme":"k","AccuracyScore":19,"Offset":13400000,"Duration":200000},{"Phoneme":"s","AccuracyScore":0,"Offset":13700000,"Duration":200000},{"Phoneme":"t","AccuracyScore":0,"Offset":14000000,"Duration":200000}]},{"Word":"for","AccuracyScore":81,"ErrorType":"None","Offset":14300000,"Duration":1700000,"Phonemes":[{"Phoneme":"f","AccuracyScore":40,"Offset":14300000,"Duration":200000},{"Phoneme":"ax","AccuracyScore":46,"Offset":14600000,"Duration":200000},{"Phoneme":"r","AccuracyScore":100,"Offset":14900000,"Duration":1100000}]},{"Word":"me","AccuracyScore":56,"ErrorType":"None","Offset":16100000,"Duration":1300000,"Phonemes":[{"Phoneme":"eh","AccuracyScore":95,"Offset":16100000,"Duration":300000},{"Phoneme":"m","AccuracyScore":40,"Offset":16500000,"Duration":600000},{"Phoneme":"iy","AccuracyScore":40,"Offset":17200000,"Duration":200000}]}]}],"exerciseKey":"cyWnql","studentName":"abc","fileName":"R_cyWnql_READ_abc_2020-12-22T21:35:49.882Z"},"similarityValue":"0.00","accuracyScore":"26.00","accuracyScoreLabel":"poor","fluencyScore":"42.00","fluencyScoreLabel":"poor","completenessScore":"33.00","completenessScoreLabel":"poor","pronScore":"30.60","pronScoreLabel":"poor","wordCount":6,"overallScore":"72.67","overallScoreLabel":"poor"}');

  export let lastRecording;
  export let language;
  export let courseScoringType;
  export let exerciseType;
  export let exerciseDetail;

  const dispatch = createEventDispatcher();

  onMount(() => {});

  let waveform;
  let wavesurfer;
  let waveformTimeline;
  let playing = false;

  let initWaveFormDone = false;

  const starLevels = {
    1: 30,
    2: 50,
    3: 65,
    4: 80,
    4: 90,
  };

  export let displayConfig = {
    radar: true,
    smile: true,
    studentScore: true,
    teacherScore: true,
    text: true,
    breakdownWord: true,
    breakdownPhoneme: true,
    debug: true,
  };

  let textToReadFull;

  $: {
    if (
      (exerciseType === "READ_IMAGE" ||
        exerciseType === "QUESTION_FIX_ANSWER") &&
      exerciseDetail?.answer
    ) {
      textToReadFull = exerciseDetail?.answer;
    } else {
      textToReadFull = resultData?.data.NBest[0].Display;
    }
  }

  function tryAgain() {
    mixpanel.track("Student Results Try Again Button Clicked");
    dispatch("tryAgainExercise", {});
    //window.location.reload();
  }

  function openLesson() {
    console.log("openLesson");
    const msg = {
      text: "PIN OK",
      pin: Number(loginDetail?.lessonId),
      userName: loginDetail?.userName,
      loginToken: loginDetail?.loginToken,
      lessonId: Number(loginDetail?.lessonId),
    };
    dispatch("openLesson", msg);
  }

  function nextExercise() {
    mixpanel.track("Student Results Next Button Clicked");
    const msg = {};
    dispatch("nextExercise", msg);
  }

  async function initWaveWorm() {
    console.log("xxx", resultData);
    initWaveFormDone = true;
    waveform.innerHTML = "";
    console.log("initWaveWorm");

    //waveform = document.getElementById("waveform");

    let wavesurferOptions = {
      container: "#waveform",
      waveColor: "violet",
      progressColor: "purple",
      loaderColor: "purple",
      cursorColor: "navy",
      plugins: [
        WaveSurfer.timeline.create({
          container: "#wave-timeline",
        }),
      ],
    };

    wavesurfer = WaveSurfer.create(wavesurferOptions);

    let iOS = navigator.vendor == "Apple Computer, Inc.";
    console.log("ios", iOS);

    if (!iOS) {
      wavesurfer.loadBlob(lastRecording.blob);
      animateScroll.scrollToBottom();
    } else {
      lastRecording.blob = await processBlobToWav(lastRecording.blob);
      wavesurfer.loadBlob(lastRecording.blob);
      animateScroll.scrollToBottom();
    }

    wavesurfer.drawer.on("click", function () {
      console.log("click wavesurfer");
      selectWordBySlice();
    });

    wavesurfer.on("finish", () => {
      console.log("Finish");
      playing = false;
    });

    wavesurfer.on("pause", () => {
      console.log("Pause");
      playing = false;
    });
  }

  console.log("xxx", resultData);

  function showDetailsForWords(w) {
    console.log("showDetailsForWords", w);
  }

  function showDetailsForWordsMore(w) {
    selectedWord = w;
    seekToWordSlice();
  }

  function playPauseClick() {
    console.log("pauseAudio");
    wavesurfer.playPause();
    playing = wavesurfer.isPlaying();
  }

  function replayWordSlice() {
    console.log("reaplayWordSlice", selectedWord);

    let startTime = selectedWord.Offset / 10000000;
    let endTime = startTime + selectedWord.Duration / 10000000;

    if (startTime && endTime) {
      wavesurfer.play(startTime, endTime);
      playing = wavesurfer.isPlaying();
    }
  }

  function seekToWordSlice() {
    let startTime = selectedWord.Offset / 10000000;
    let seekTarget = startTime / wavesurfer.getDuration();

    if (seekTarget >= 0 && seekTarget <= 1) {
      wavesurfer.seekTo(seekTarget);
    }
  }

  function selectWordBySlice() {
    let position = wavesurfer.getCurrentTime();
    resultData?.data.NBest[0]?.Words.forEach((w) => {
      let startTime = w.Offset / 10000000;
      let endTime = startTime + w.Duration / 10000000;
      let inside = startTime <= position && position <= endTime;
      if (inside) {
        console.log(w.Word, inside);
        showDetailsForWordsMore(w);
      }
    });
  }

  function convertErrorCodeToTest(errorType) {
    if (errorType === "Omission") {
      return "Word not detected";
    } else if (errorType === "Insertion") {
      return "Added";
    } else if (errorType === "Mispronunciation") {
      return "Mispronounced";
    }
  }

  let selectedWord; // = JSON.parse('{"Word":"read","AccuracyScore":15,"ErrorType":"Mispronunciation","Offset":11000000,"Duration":800000,"Phonemes":[{"Phoneme":"r","AccuracyScore":0,"Offset":11000000,"Duration":200000},{"Phoneme":"eh","AccuracyScore":0,"Offset":11300000,"Duration":200000},{"Phoneme":"d","AccuracyScore":46,"Offset":11600000,"Duration":200000}]}');
</script>

{#if resultData}
  <div class="row resultHeading5">
    <div class="col">
      <h5>Results</h5>
    </div>
  </div>

  {#if courseScoringType === "SCORING_NO_SCORE"}
    <div class="row justify-content-lg-center">
      <div class="col-lg-6">
        {#if displayConfig.teacherScore}
          <div class="card">
            <div class="card-body container justify-content-center row">
              {#if Number.parseFloat(resultData?.overallScore) > 30}
                <h3>
                  Great job! <i class="fa fa-star checked" /><i
                    class="fa fa-star checked"
                  /><i class="fa fa-star checked" />
                </h3>
              {:else}
                <h3>Hm…please try again!</h3>
              {/if}
            </div>
          </div>
        {/if}
      </div>
    </div>
  {:else if courseScoringType === "SCORING_5_STARS"}
    <div class="row justify-content-lg-center">
      <div class="col-lg-6">
        {#if displayConfig.teacherScore}
          <div class="card">
            <div class="card-body container">
              <div class="row mb-2">
                <div class="score score-overall col-6">Overall Score:</div>
                <div class="col-6" style="min-width=8em;">
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.overallScore) >
                      starLevels[1]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.overallScore) >
                      starLevels[2]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.overallScore) >
                      starLevels[3]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.overallScore) >
                      starLevels[4]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.overallScore) >
                      starLevels[5]}
                  />
                </div>
              </div>
              <div class="row">
                <div class="score col-6">Pronunciation:</div>
                <div class="col-6" style="min-width=8em;">
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.pronScore) >
                      starLevels[1]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.pronScore) >
                      starLevels[2]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.pronScore) >
                      starLevels[3]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.pronScore) >
                      starLevels[4]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.pronScore) >
                      starLevels[5]}
                  />
                </div>
              </div>
              <!-- Read || SelfPractice mode with text -->
              {#if exerciseType === "READ" || (exerciseType === "SELF_PRACTICE" && exerciseDetail?.selfPracticeText && exerciseDetail?.selfPracticeText.length > 0)}
                <div class="row">
                  <div class="score col-6">Word Match:</div>

                  <div class="col-6" style="min-width=8em;">
                    <span
                      class="fa fa-star"
                      class:checked={Number.parseFloat(
                        resultData?.completenessScore,
                      ) > starLevels[1]}
                    />
                    <span
                      class="fa fa-star"
                      class:checked={Number.parseFloat(
                        resultData?.completenessScore,
                      ) > starLevels[2]}
                    />
                    <span
                      class="fa fa-star"
                      class:checked={Number.parseFloat(
                        resultData?.completenessScore,
                      ) > starLevels[3]}
                    />
                    <span
                      class="fa fa-star"
                      class:checked={Number.parseFloat(
                        resultData?.completenessScore,
                      ) > starLevels[4]}
                    />
                    <span
                      class="fa fa-star"
                      class:checked={Number.parseFloat(
                        resultData?.completenessScore,
                      ) > starLevels[5]}
                    />
                  </div>
                </div>
              {/if}
              <div class="row">
                <div class="score col-6">Fluency:</div>

                <div class="col-6" style="min-width=8em;">
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.fluencyScore) >
                      starLevels[1]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.fluencyScore) >
                      starLevels[2]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.fluencyScore) >
                      starLevels[3]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.fluencyScore) >
                      starLevels[4]}
                  />
                  <span
                    class="fa fa-star"
                    class:checked={Number.parseFloat(resultData?.fluencyScore) >
                      starLevels[5]}
                  />
                </div>
              </div>
            </div>
          </div>
        {/if}
      </div>
    </div>
  {:else}
    <div class="row">
      <div class="col-lg-8">
        {#if displayConfig.radar}
          <div class="card">
            <div class="card-body">
              <ResultChartRadar {resultData} {exerciseType} {exerciseDetail} />
            </div>
          </div>
        {/if}
      </div>
      <div class="col-lg-4">
        {#if displayConfig.teacherScore}
          <div class="card">
            <div class="card-body container">
              <div class="row">
                <div class="score score-overall col-8">Overall Score:</div>
                <div class="col-4 score-overall">
                  <span
                    id="resultScoringOverallScore"
                    class={resultData?.overallScoreLabel}
                    >{Number.parseFloat(resultData?.overallScore).toFixed(
                      0,
                    )}</span
                  >
                </div>
              </div>
              {#if Array.isArray(resultData?.data?.scoringReasons) && resultData?.data?.scoringReasons?.length > 0}
                <h3>Error reasons</h3>
                <div class="row">
                  <div class="col">
                    <ol>
                      {#each resultData?.data?.scoringReasons as reason, i}
                        <li>{$_(reason)}</li>
                      {/each}
                    </ol>
                  </div>
                </div>
              {/if}

              <div class="row">
                <div class="topSeparator" />
              </div>
              <div class="row">
                <div class="score col-8">Pronunciation:</div>
                <div class="col-4">
                  <span
                    id="resultScoringPronunciation"
                    class={resultData?.pronScoreLabel}
                    >{Number.parseFloat(resultData?.pronScore).toFixed(0)}</span
                  >
                </div>
              </div>
              {#if exerciseType === "READ" || (exerciseType === "SELF_PRACTICE" && exerciseDetail?.selfPracticeText && exerciseDetail?.selfPracticeText.length > 0)}
                <div class="row">
                  <div class="score col-8">Word Match:</div>
                  <div class="col-4">
                    <span
                      id="resultScoringWordMatch"
                      class={resultData?.completenessScoreLabel}
                      >{Number.parseFloat(
                        resultData?.completenessScore,
                      ).toFixed(0)}</span
                    >
                  </div>
                </div>
              {/if}
              <div class="row">
                <div class="score col-8">Fluency:</div>
                <div class="col-4">
                  <span
                    id="resultScoringFluency"
                    class={resultData?.fluencyScoreLabel}
                    >{Number.parseFloat(resultData?.fluencyScore).toFixed(
                      0,
                    )}</span
                  >
                </div>
              </div>

              <div class="row">
                <div class="topSeparator" />
              </div>
              <div class="row">
                <div class="score col-8">WordCount:</div>
                <div class="col-4"><span>{resultData?.wordCount}</span></div>
              </div>
              <div class="row">
                <div class="score col-8">Duration:</div>
                <div class="col-4">
                  <span>{convertSecToMin(resultData?.durationSecond)}</span>
                </div>
              </div>
              <div class="row">
                <div class="score col-8">Words Per Minute:</div>
                <div class="col-4">
                  <span
                    >{Number.parseFloat(resultData?.wordPerMinute).toFixed(
                      0,
                    )}</span
                  >
                </div>
              </div>
            </div>
          </div>
        {/if}
      </div>
    </div>
  {/if}

  <div class="row topSeparator">
    <div class="col text-center">
      <button
        on:click={initWaveWorm}
        class="btn btn-primary btn-block more-details"
        style="font-size: 32px;"
        type="button"
        data-toggle="collapse"
        data-target="#collapseFive"
        aria-expanded="false"
        aria-controls="collapseFive"
      >
        More details ...
      </button>
    </div>
  </div>
  <div class="row topSeparator" class:initWaveFormDone={!initWaveFormDone}>
    <div class="col">
      {#if displayConfig.breakdownPhoneme}
        <div class="card">
          <div class="card-header">
            <p>Click on a word to play it.</p>
          </div>
          <div class="card-body">
            <div id="resultDetailsWithPhonemes">
              {#each resultData?.data.NBest[0]?.Words as w, i}
                {#if w.SensayWordScore}
                  {#if w.SensayWordScore >= 90 && w.ErrorType === "None"}
                    <span
                      class="badge badge-pill badge-excellent"
                      data-tooltip="Score: {w.SensayWordScore}"
                      on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                    >
                  {:else if w.ErrorType === "Mispronunciation" || w.ErrorType === "Insertion"}
                    <span
                      class="badge badge-pill badge-miss"
                      data-tooltip={convertErrorCodeToTest(w.ErrorType)}
                      on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                    >
                  {:else if w.ErrorType === "Omission"}
                    <span
                      class="badge badge-pill badge-error"
                      data-tooltip={convertErrorCodeToTest(w.ErrorType)}
                      on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                    >
                  {:else if w.SensayWordScore >= 80}
                    <span
                      class="badge badge-pill badge-good"
                      data-tooltip="Score: {w.SensayWordScore}"
                      on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                    >
                  {:else if w.SensayWordScore >= 70}
                    <span
                      class="badge badge-pill badge-fair"
                      data-tooltip="Score: {w.SensayWordScore}"
                      on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                    >
                  {:else if w?.ErrorType != "None"}
                    <span
                      class="badge badge-pill badge-bad"
                      data-tooltip="Score: {w.SensayWordScore} - {convertErrorCodeToTest(
                        w.ErrorType,
                      )}"
                      on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                    >
                  {:else}
                    <span
                      class="badge badge-pill badge-bad"
                      data-tooltip="Score: {w.SensayWordScore}"
                      on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                    >
                  {/if}
                {:else if w.AccuracyScore >= 90 && w.ErrorType === "None"}
                  <span
                    class="badge badge-pill badge-excellent"
                    data-tooltip="Score: {w.AccuracyScore}"
                    on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                  >
                {:else if w.ErrorType === "Mispronunciation" || w.ErrorType === "Insertion"}
                  <span
                    class="badge badge-pill badge-miss"
                    data-tooltip={convertErrorCodeToTest(w.ErrorType)}
                    on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                  >
                {:else if w.ErrorType === "Omission"}
                  <span
                    class="badge badge-pill badge-error"
                    data-tooltip={convertErrorCodeToTest(w.ErrorType)}
                    on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                  >
                {:else if w.AccuracyScore >= 80}
                  <span
                    class="badge badge-pill badge-good"
                    data-tooltip="Score: {w.AccuracyScore}"
                    on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                  >
                {:else if w.AccuracyScore >= 70}
                  <span
                    class="badge badge-pill badge-fair"
                    data-tooltip="Score: {w.AccuracyScore}"
                    on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                  >
                {:else if w?.ErrorType != "None"}
                  <span
                    class="badge badge-pill badge-bad"
                    data-tooltip="Score: {w.AccuracyScore} - {convertErrorCodeToTest(
                      w.ErrorType,
                    )}"
                    on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                  >
                {:else}
                  <span
                    class="badge badge-pill badge-bad"
                    data-tooltip="Score: {w.AccuracyScore}"
                    on:click={() => showDetailsForWordsMore(w)}>{w.Word}</span
                  >
                {/if}
              {/each}
            </div>
            <div id="waveform" bind:this={waveform} />
            <div id="wave-timeline" bind:this={waveformTimeline} />
            <div id="resultDetailsWithPhonemesDetail">
              <div class="topSeparator" style="text-align: center;">
                <button
                  class="btn btn-primary record"
                  type="button"
                  id="reaplayPlayStart"
                  on:click={playPauseClick}
                  >{#if playing}<i
                      class="fa fa-pause"
                      style="margin: 0px 3px;"
                    />{:else}<i
                      class="fa fa-play"
                      style="margin: 0px 3px;"
                    />{/if}You</button
                >

                <TextToSpeech2 textToRead={textToReadFull} {language} />
              </div>
              {#if selectedWord}
                <div>
                  Word:
                  <strong id="detailWord">{selectedWord?.Word || ""}</strong>
                </div>
                <div>
                  Score:
                  <strong id="detailAccuracy"
                    >{#if selectedWord?.SensayWordScore}
                      {selectedWord?.SensayWordScore || ""}
                    {:else}
                      {selectedWord?.AccuracyScore || ""}
                    {/if}
                  </strong>
                </div>
                {#if selectedWord?.ErrorType != "None"}
                  <div>
                    Area to improve:
                    <strong id="detailError"
                      >{convertErrorCodeToTest(selectedWord?.ErrorType) ||
                        ""}</strong
                    >
                  </div>
                {/if}
                <div />

                <div>
                  <div class="col" style="text-align: center;">
                    {#if selectedWord}
                      <button
                        class="btn btn-primary record"
                        type="button"
                        id="reaplayWord"
                        on:click={replayWordSlice}
                        disabled={!selectedWord?.Duration}
                        >{#if playing}<i
                            class="fa fa-pause"
                            style="margin: 0px 3px;"
                          />{:else}<i
                            class="fa fa-play"
                            style="margin: 0px 3px;"
                          />{/if} "{selectedWord?.Word || ""}"</button
                      >

                      <TextToSpeech2
                        textToRead={selectedWord?.Word}
                        {language}
                      />
                    {/if}
                  </div>
                  <table class="table">
                    <thead>
                      <th colspan="100%" style="text-align: center;" />
                    </thead>
                    <tbody id="detailPhonemes" class="detailPhonemes">
                      {#if Array.isArray(selectedWord?.Phonemes)}
                        <tr>
                          {#each selectedWord?.Phonemes as ph}
                            {#if ph?.AccuracyScore >= 90}
                              <td class="excellent">
                                {mapPronToIpa(ph?.Phoneme)}
                              </td>
                            {:else if ph?.AccuracyScore > 70}
                              <td class="good">
                                {mapPronToIpa(ph?.Phoneme)}
                              </td>
                            {:else if ph?.AccuracyScore > 50}
                              <td class="poor">
                                {mapPronToIpa(ph?.Phoneme)}
                              </td>
                            {:else}
                              <td class="bad">
                                {mapPronToIpa(ph?.Phoneme)}
                              </td>
                            {/if}
                          {/each}
                        </tr>
                        <tr>
                          {#each selectedWord?.Phonemes as ph}
                            {#if ph?.AccuracyScore >= 90}
                              <td class="excellent">
                                {ph?.AccuracyScore.toFixed(0)}
                              </td>
                            {:else if ph?.AccuracyScore > 70}
                              <td class="good">
                                {ph?.AccuracyScore.toFixed(0)}
                              </td>
                            {:else if ph?.AccuracyScore > 50}
                              <td class="poor">
                                {ph?.AccuracyScore.toFixed(0)}
                              </td>
                            {:else}
                              <td class="bad">
                                {ph?.AccuracyScore.toFixed(0)}
                              </td>
                            {/if}
                          {/each}
                        </tr>
                      {/if}
                    </tbody>
                  </table>
                </div>
              {/if}
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .initWaveFormDone {
    display: none;
  }

  .topSeparator {
    margin-top: 1em;
  }

  .resultFace {
    font-size: 10em;
  }

  .excellent {
    color: #008154;
    font-size: 1em;
  }

  .good {
    color: #40ac86;
    font-size: 1em;
  }

  .poor {
    color: #f7ba31;
    font-size: 1em;
  }

  .bad {
    color: #fe5b5b;
    font-size: 1em;
  }

  .textResultPre {
    font-family: Helvetica;
    font-size: 1.5em;
    overflow: auto;
    white-space: pre-wrap;
  }

  [data-tooltip]:before {
    /* needed - do not touch */
    content: attr(data-tooltip);
    position: absolute;
    opacity: 0;

    /* customizable */
    transition: all 0.15s ease;
    padding: 10px;
    color: #333;
    border-radius: 10px;
    box-shadow: 2px 2px 1px silver;
  }

  [data-tooltip]:hover:before {
    /* needed - do not touch */
    opacity: 1;

    /* customizable */
    background: #ffcc07ff;
    margin-top: -50px;
    margin-left: 20px;
  }

  [data-tooltip]:not([data-tooltip-persistent]):before {
    pointer-events: none;
  }

  .badge {
    margin-right: 3px;
    font-weight: 500;
    font-size: 80%;
    cursor: pointer;
  }

  .badge-excellent {
    background: #008154ff;
    color: ivory;
  }

  .badge-good {
    background: #40ac86ff;
    color: ivory;
  }

  .badge-fair {
    background: #f7ba31ff;
    color: ivory;
  }

  .badge-bad {
    background: #fe5b5bff;
    color: ivory;
  }

  .badge-error {
    background: #fe5b5bff;
    color: ivory;
    text-decoration: line-through;
  }

  .badge-miss {
    background: #fe5b5bff;
    color: ivory;
    text-decoration-color: ivory;
    text-decoration-line: underline;
    text-decoration: dashed;
  }

  .detailPhonemes td {
    text-align: center;
    padding: 1px;
  }

  .checked {
    color: orange;
  }

  .score-overall {
    font-weight: 600;
    font-size: large;
  }

  .more-details {
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: normal;
    font-size: 1.2em;
    line-height: 1.6em;

    border-radius: 16px;

    background: #00a094;
    color: #ffffff;
    border-color: #00a094;
  }

  .record {
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: normal;
    font-size: 1.2em;
    line-height: 1.6em;

    border-radius: 16px;

    background: #00a094;
    color: #ffffff;
    border-color: #00a094;
  }
</style>
